import { Button, Carousel, Spin, Tabs } from 'antd'
import { SDrawerOrModal, SEditor } from 'shj-components'
import styles from './index.module.less'
import PDFPreview from '../PDFPreview'
import { useEffect } from 'react'
import _ from 'lodash'

export default function ProductDetailDrawer(props: any) {
  const { previewObj, setPreviewObj } = props
  const openNewWindow = (url: string) => {
    if (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) {
      window.open(url)
    } else {
      window.open('http://' + url)
    }
  }
  useEffect(() => {
      let productDetailList = previewObj?.data?.attachList
      productDetailList = productDetailList?.map((item: any) => {
        return {
          ...item,
          key: _.uniqueId(),
        }
      })
      getDesc(productDetailList || [])
  }, [previewObj?.data?.attachList])
  const getDesc = (descType: any[]) => {
    const data = descType.map(item => ({
      ...item,
      label: (
        <div>
          <span>{item.attachName}</span>
        </div>
      ),
      children: getDetailType(item.contentType, item),
      key: item.key,
    }))
    setPreviewObj({ descType: data })
  }
  const getDetailType = (type: string, obj) => {
    const { attachPath, content } = obj
    const typeObj = {
      attachContent: (
        <SEditor readOnly init={{ toolbar: false, menubar: false, plugins: [] }} value={content} />
      ),
      attachPDF: <PDFPreview url={attachPath} />,
      attachVideo: <video style={{ width: '100%' }} src={attachPath} controls={true} />,
      attachURL: (
        <Button type="link" onClick={() => openNewWindow(attachPath)}>
          {attachPath}
        </Button>
      ),
    }
    return typeObj[type]
  }

  return (
    <SDrawerOrModal
      open={previewObj.open}
      title={'产品详情'}
      onCancel={() => setPreviewObj({ open: false, descType: [] })}
      antdProps={{ footer: [] }}
    >
      <Spin spinning={previewObj.loading}>
        <Carousel arrows infinite={false} autoplay className={styles.carouselBox}>
          {previewObj?.data?.imageUrls?.map((item: any) => {
            return (
              <div style={{ width: '100%', height: '100%' }}>
                <img
                  src={item}
                  style={{
                    margin: '0 auto',
                    objectFit: 'contain',
                    width: '100%',
                    height: '100%',
                  }}
                  alt=""
                />
              </div>
            )
          })}
        </Carousel>
        {previewObj.descType?.length ? (
          <Tabs
            tabBarStyle={{ position: 'sticky', top: 0, zIndex: 2, background: '#fff' }}
            items={previewObj.descType}
            hideAdd
          />
        ) : null}
      </Spin>
    </SDrawerOrModal>
  )
}
